
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getBranchservicetype = async () => {
  return await get<ApiResponse<any[]>>("/branchservicetype").then((res)=>{
      return res
    })
};

 